<script>
	import { onMount, createEventDispatcher } from "svelte";
	import { SupportUser, Response,isFormAlreadySubmitted } from "./store.js";
	import Steps from "./steps.svelte";
	import wrappedFetch from "../../wrappedFetch.js";
	import Field from "../../components/FormField.svelte";
	import Select from "../../components/HTMLElements/Select.svelte";
	import Radio from "../../components/HTMLElements/RadioInput.svelte";
	import CheckBox from "../../components/HTMLElements/CheckBoxInput.svelte";
	import * as objectWrapper from "../../components/Utils/ObjectWrapper.js";
  	import * as validate from "../../components/Utils/ValidateFormFIelds.js";
	const dispatch = new createEventDispatcher();
	let selectedLA;
	let las = [];
	let issues = [];
	let selectedIssue;
	let errMsg = "";
	let isDirty = false;

	let problemNotSolved = false;
	let isPageLoading = true;
	
	let radioItems = [   
    { value: "Yes", TextValue: "Yes"},
    { value: "No", TextValue: "No"},
    { value: "Unsure", TextValue: "Unsure"}
  ];
  let radioParams = { item: radioItems, required: true};
  //let navigate,complete,lookandfeel,locate;
    
//   let navigate = { value: "", isDirty: false, isValid: false };
//   let complete = { value: "", isDirty: false, isValid: false };
//   let lookandfeel = { value: "", isDirty: false, isValid: false };
//   let locate = { value: "", isDirty: false, isValid: false };
  let wrappedObj ;
  let navigate,complete,lookandfeel,locate;
  let formObject={navigate,complete,lookandfeel,locate}

	const getBorough = async () => {
		let resp = await wrappedFetch(
			"/borough/GetBoroughs?isAdmitting=true",
			{ method: "post" }
		);
		return await resp.json();
	};	

	const getContent = async () => {
		const getHelpContents = await wrappedFetch(
			"helpcontent?helpId=contactissues"
		);
		let resp = await getHelpContents.json();
		let id = 1;
		resp.forEach((r, i) => {
			if (r.type == "h3") {
				issues.push({ id: id, label: r.text, helpText: resp[i + 1].text });
				id++;
			}
		});
		//return issues;

		// return resp.filter(r => r.type=="h2")[0].text;
	};
	const gotoNext = () => {
		// isDirty = true;

		// if (!selectedLA || !selectedIssue) {
		// 	errMsg = "Please ensure that you have completed the required fields.";
		// 	return;
		// }

		// $Response.la = selectedLA.label;
		// $Response.issue = selectedIssue.label;
		// $Response.problemNotSolved = problemNotSolved;
		// $Response.step2 = true;	
		if (!validate.validate(wrappedObj)) {
        errMsg = "Please check required fields have valid data.";
        wrappedObj = wrappedObj;      
        return;
    }
        $Response.navigate = wrappedObj.navigate.value
        $Response.complete =  wrappedObj.complete.value
        $Response.lookandfeel = wrappedObj.lookandfeel.value
		$Response.locate=wrappedObj.locate.value
		$Response.step2 = true;
      
		dispatch("pageChange", "/furtherfeedback/step3");
	};
	onMount(async () => {
if (!$Response.step1 || isFormAlreadySubmitted()) dispatch("pageChange", "/furtherfeedback/step1");
	if($Response.step2)
        formObject = {navigate:$Response.navigate,complete:$Response.complete,lookandfeel:$Response.lookandfeel,locate:$Response.locate}			
		wrappedObj = objectWrapper.wrapObject(formObject);		
		debugger;
		isPageLoading = false;
	});
</script>
<style>
    .icon{
        color: #209cee;
        font-size: 1.5rem;
        cursor: default;
    }
</style>
{#if !isPageLoading}
	<Steps
		backUrl="/furtherfeedback/step1"
		buttonText="Next"		
		bind:isPageLoading
		on:handleNext={() => gotoNext()}
		on:pageChange={(event) => dispatch('pageChange', event.detail)}>
		<div class="column">
			<Field      
    		label="1. Did you find the website easy to navigate?"/>
			<Radio
			bind:group={wrappedObj.navigate.value}
			bind:isDirty={wrappedObj.navigate.isDirty}
			bind:isValid={wrappedObj.navigate.isValid}
			label="the website easy to navigate"
			{...radioParams}
			marginRight="10px"
			/>

			<Field      
    		label="2. Did you find the application easy to complete?"/>
			<Radio
		 	bind:group={wrappedObj.complete.value}
			bind:isDirty={wrappedObj.complete.isDirty}
			bind:isValid={wrappedObj.complete.isValid}
			label="the application easy to complete"
			{...radioParams}
			marginRight="10px"
			/>

			<Field      
    		label="3. Did you like the look and feel of the website?"/>
			<Radio
			bind:group={wrappedObj.lookandfeel.value}
			bind:isDirty={wrappedObj.lookandfeel.isDirty}
			bind:isValid={wrappedObj.lookandfeel.isValid}
			label="the look and feel of the website"
			{...radioParams}
			marginRight="10px"
			/>

			<Field      
    		label="4. Did you find information easy to locate?"/>
			<Radio
			bind:group={wrappedObj.locate.value}
			bind:isDirty={wrappedObj.locate.isDirty}
			bind:isValid={wrappedObj.locate.isValid}
			label="information easy to locate"
			{...radioParams}
			marginRight="10px"
			/>
		</div>
	</Steps>
{/if}
